import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../../common_comp/Layout/Layout";

const Copyright = () => {
  return (
    <Layout>
      <Container className="my-5   mx-auto ">
        <Row className="px-3    ">
          <h1 className="text-center fw-bold mb-4">Copyright</h1>
          <p>
            All articles published in the Journal of Applied Bioanalysis are
            open access articles distributed under the terms of the Creative
            Commons Attribution License (CC-BY) which permits any use,
            distribution, and reproduction in any medium, provided the original
            author(s) and source are credited. The copyright of the article is
            due to the CC-BY Attribution License with the Author(s) of the
            articles.
          </p>

          <strong className="my-2 fs-5">
            REUSE OF COPYRIGHT MATERIALS-IMPORTANT{" "}
          </strong>
          <p>
            If a figure or table has been published previously (even if you are
            the author), acknowledge the original source and submit written
            permission from the copyright holder to reproduce the figure(s) or
            Table(s) is mandatory and you as being author are responsible for
            obtaining permissions to use material owned by publishers. Since the
            permission-seeking process can be a time-consuming process, it is
            wise to begin soliciting for reprints rights as soon as possible
            during the writing of the manuscript. More information is available
            at the Copyright Clearance Center (www.copyright.com)
          </p>
        </Row>
      </Container>
    </Layout>
  );
};

export default Copyright;
